

















































import { Component, Vue } from 'vue-property-decorator'
import { getCollegeList } from '@/apis/myInfo/myInfo.ts'
import { updateInfo } from '@/apis/myInfo/myInfo.ts'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import i18n from '@/lang';

@Component({})
export default class SchoolModify extends Vue {
  private schoolName = this.userInfo.school
  private show: boolean = false
  private isSchool: number = -1
  private schoolList: any = []
  private searchText: any = ''
  private index: number = -1
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  keep() {
    updateInfo({
      username: this.userInfo.username,
      school: this.schoolName,
      department: this.userInfo.department,
      teachcourse: this.userInfo.teachcourse,
      stno: this.userInfo.stno,
      majors: this.userInfo.majors,
      classno: this.userInfo.additionInfo!.classno,
      enrolltime: this.userInfo.additionInfo!.enrolltime,
      grade: this.userInfo.additionInfo!.grade,
    })
      .then((res) => {
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.back()
        })
      })
      .catch((e) => {})
  }
  confim() {
    this.show = false

    if (this.schoolList.length == 0) {
      this.schoolName = this.searchText
    }
  }
  onCancelSearch() {
    this.searchText = ''
    this.getSchoolList(this.searchText)
  }
  inputText() {
    this.getSchoolList(this.searchText)
  }
  showPopup() {
    this.show = true
  }
  chooseSchoole(index: number) {
    this.index = index
    this.schoolName = this.schoolList[index].name
    this.isSchool = index
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('Home.学校') as string,
      showTitle: true,
    })
    this.getSchoolList('0')
  }
  getSchoolList(searchText: string) {
    getCollegeList({ search: searchText }).then((res) => {
      this.schoolList = res
    })
  }
}
